import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { marcarModo } from './lib/entorno';
import './styles/globals.css';
import './styles/tour.css'; // Sprint 9.1 — driver.js + overrides

/**
 * Sprint 49 (PoC Web) — En Electron, `window.api` lo inyecta el preload. En web
 * no hay preload: cargamos el shim HTTP (`apiWeb`) antes de montar la app. Los
 * componentes usan `window.api.*` sin enterarse del transporte.
 */
async function bootstrap(): Promise<void> {
  if (!window.api) {
    const { apiWeb } = await import('./webapi/apiWeb');
    (window as unknown as { api: typeof apiWeb }).api = apiWeb;
    // Sprint 56 — sin preload estamos en un navegador: la impresión térmica
    // pasa a hacerse del lado del cliente (ver `lib/impresionNavegador.ts`).
    marcarModo('web');
  }

  const container = document.getElementById('root');
  if (!container) throw new Error('No #root element found');

  createRoot(container).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}

void bootstrap();
